import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { WlProfilesToolbarEvent } from './toolbar-profiles-broadcast-event.model';

/**
 * service to broadcast events happening to or from the events toolbar
 */
@Injectable()
export class WlProfilesToolbarBroadcastService extends Subject<WlProfilesToolbarEvent> {
  /**
   * construct
   */
  public constructor() {
    super();
  }

  /**
   * broadcast an event
   * @param event
   */
  public broadcast(event: WlProfilesToolbarEvent): void {
    this.next(event);
  }
}
